import { AuthService } from './auth.service';
import { DbService } from './db.service';
import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/messaging';
import { AngularFireFunctions } from '@angular/fire/functions';
import { ToastController, Platform } from '@ionic/angular';
import { tap, mergeMapTo } from 'rxjs/operators';

// Fixing temporary bug in AngularFire
import * as app from 'firebase/app';
import 'firebase/messaging';

import { from } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FcmService {
  token;

  constructor(
    private afMessaging: AngularFireMessaging,
    private afFun: AngularFireFunctions,
    private toastController: ToastController,
    public platform: Platform,
    private db: DbService,
    private auth: AuthService
  ) {
    try {
      // tslint:disable-next-line: variable-name
      const messaging = app.messaging();
      messaging.onTokenRefresh = messaging.onTokenRefresh.bind(messaging);
      messaging.onMessage = messaging.onMessage.bind(messaging);
    } catch (e) {
      console.log(e);
    }
  }

  async makeToast(message) {
    const toast = await this.toastController.create({
      message,
      duration: 500,
      position: 'top',
      buttons: [
        {
          text: 'Done',
          role: 'cancel',
        },
      ],
    });
    toast.present();
  }

  getPermission(user) {
    let token$;

    token$ = from(this.getPermissionWeb());

    token$
      .pipe(
        tap((token) => {
          this.token = token;
        })
      )
      .subscribe((data) => {
        this.saveToken(user, this.token);
      });
  }

  private async getPermissionWeb() {
    await app.messaging().requestPermission();
    return await app.messaging().getToken();
  }

  listenToMessages() {
    let messages$;

    messages$ = this.afMessaging.messages;

    return messages$.pipe(tap((v) => this.showMessages(v)));
  }

  private showMessages(payload) {
    let body;
    if (this.platform.is('android')) {
      body = payload.body;
    } else {
      body = payload.notification.body;
    }
    this.makeToast(body);
  }

  sub(topic) {
    this.afFun
      .httpsCallable('subscribeToTopic')({ topic, token: this.token })
      .pipe(tap((_) => this.makeToast(`subscribed to ${topic}`)))
      .subscribe();
  }

  unsub(topic) {
    this.afFun
      .httpsCallable('unsubscribeToTopic')({ topic, token: this.token })
      .pipe(tap((_) => this.makeToast(`unsubscribed to ${topic}`)))
      .subscribe();
  }

  monitorRefresh(user) {
    app.messaging().onTokenRefresh(async () => {
      this.getPermission(user);
    });
  }

  private saveToken(user, token) {
    const currentTokens = user.fcmTokens || {};

    if (!currentTokens[token] && user) {
      const tokens = { ...currentTokens, [token]: true };
      this.db.updateAt(`users/${user}`, { fcmTokens: token });
    }
  }
}
